import {useContext} from 'react';

import {ServiceCaseDetailActionsContext} from './ServiceCaseDetailActionsContext';

export function useServiceCaseDetailActions() {
  const context = useContext(ServiceCaseDetailActionsContext);
  if (!context) {
    throw new Error(
      'useServiceCaseDetailActions must be used within ServiceCaseDetailActionsProvider'
    );
  }
  return context;
}
